module.exports = "https://www.gc-qa.gnp.com.mx/fdffca99eecc3127d23b412eedc21f67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/delete_black_24dp.svg
// module id = 1817
// module chunks = 0